var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode-container",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('vue-qrcode',_vm._b({staticClass:"qrcode",attrs:{"width":_vm.width}},'vue-qrcode',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }